import { useState } from 'react'
import { Clock, DoorOpen, Download, Users } from 'lucide-react'
import PromotionLoginRecordsTab from './PromotionLoginRecordsTab'
import PromotionInstallRecordsTab from './PromotionInstallRecordsTab'
import InstallOpenRecordsTab from './InstallOpenRecordsTab'
import PreInstallRecordsTab from './PreInstallRecordsTab'

const SUB_TABS = [
  { id: 'promotion-login-records', label: '渠道归属明细(CPA)', icon: Users },
  { id: 'promotion-install-records', label: '推广安装记录(CPD)', icon: Download },
  { id: 'install-open-records', label: '安装打开记录', icon: DoorOpen },
  { id: 'pre-install-records', label: '安装前置记录', icon: Clock }
]

export default function InstallAndLoginRecordsTab() {
  const [activeSubTab, setActiveSubTab] = useState('promotion-login-records')

  const renderContent = () => {
    switch (activeSubTab) {
      case 'promotion-install-records':
        return <PromotionInstallRecordsTab />
      case 'install-open-records':
        return <InstallOpenRecordsTab />
      case 'pre-install-records':
        return <PreInstallRecordsTab />
      case 'promotion-login-records':
      default:
        return <PromotionLoginRecordsTab />
    }
  }

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <div className="flex flex-wrap gap-3">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive = activeSubTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-900/30 dark:text-blue-400'
                    : 'border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-400 dark:hover:bg-gray-700'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>

      {renderContent()}
    </div>
  )
}
